import React from 'react';
import InternalServerError from '../../../components/Errors/InternalServerError';

const InternalServerErrorPage = () => {
  return <InternalServerError />;
};

export default InternalServerErrorPage;
